import { render } from "./PoliticaPrivacidad.vue?vue&type=template&id=1c37c716&scoped=true"
import script from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"

import "./PoliticaPrivacidad.vue?vue&type=style&index=0&id=1c37c716&lang=scss&scoped=true"

import exportComponent from "C:\\proyectos-alliances\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c37c716"]])

export default __exports__